import NewsCard from "./NewsCard";
import { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from "../../../apiConfig";
import { ChevronLeft, ChevronRight } from 'lucide-react';

const NEWS_GAP = 32;

function News() {
    const navigate = useNavigate();
    const [news, setNews] = useState([]);
    const sliderRef = useRef(null);

    useEffect(() => {
        let isMounted = true;
        const langEl = document.getElementById('language');
        const language = langEl ? langEl.value : '1';

        axios.get(`${API_BASE_URL}/news/${language}`).then((res) => {
            if (isMounted && res.data.news) {
                setNews(res.data.news);
            }
        }).catch(err => console.error("News error:", err));

        return () => { isMounted = false; };
    }, []);

    function scroll(dir) {
        if (sliderRef.current) {
            const cardW = sliderRef.current.offsetWidth / 4;
            sliderRef.current.scrollBy({ left: dir * (cardW + NEWS_GAP), behavior: 'smooth' });
        }
    }

    return (
        <div id="news-container" style={{ 
            maxWidth: 'var(--maxWidth)', // Match 1280px
            margin: '0 auto 60px auto', 
            padding: '0 24px', 
            display: 'flex',
            flexDirection: 'column',
            gap: '24px'
        }}>
            {/* Header Section */}
            <div style={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center', 
                width: '100%',
            }}>
                <h2 style={{
                    fontFamily: 'var(--fontDisplay)',
                    fontSize: '28px',
                    fontWeight: 800,
                    color: '#000',
                    margin: 0,
                    textTransform: 'uppercase',
                    letterSpacing: '1px'
                }}>
                    Latest News
                </h2>

                <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                    <span 
                        onClick={() => navigate('/news-list')}
                        style={{ 
                            fontFamily: 'var(--fontRajdhani)', 
                            fontWeight: 600, 
                            fontSize: '16px', 
                            textDecoration: 'underline', 
                            color: 'var(--blue)', 
                            cursor: 'pointer' 
                        }}
                    >
                        View More
                    </span>

                    {/* Navigation Arrows */}
                    <div style={{ display: 'flex', gap: '8px' }}>
                        <button onClick={() => scroll(-1)} style={arrowStyle}>
                            <ChevronLeft size={18} color="#fff" />
                        </button>
                        <button onClick={() => scroll(1)} style={arrowStyle}>
                            <ChevronRight size={18} color="#fff" />
                        </button>
                    </div>
                </div>
            </div>

            {/* News Slider Row */}
            <div
                ref={sliderRef}
                style={{
                    display: 'flex',
                    gap: `${NEWS_GAP}px`,
                    overflowX: 'auto',
                    scrollbarWidth: 'none',
                    msOverflowStyle: 'none',
                    scrollSnapType: 'x mandatory',
                    paddingBottom: '16px',
                }}
            >
                {news.map((item, i) => (
                    <div key={i} className="news-card-wrap">
                        <NewsCard data={item} />
                    </div>
                ))}
            </div>

            <style>{`
                #news-container div::-webkit-scrollbar { display: none; }
                .news-card-wrap {
                    flex: 0 0 calc(25% - 24px);
                    min-width: 0;
                    scroll-snap-align: start;
                }
                @media (max-width: 1024px) {
                    .news-card-wrap { flex: 0 0 calc(50% - 16px); }
                }
                @media (max-width: 600px) {
                    .news-card-wrap { flex: 0 0 calc(100% - 0px); }
                }
            `}</style>
        </div>
    );
}

const arrowStyle = {
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    background: '#0a1172', // Consistent Navy Blue
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    transition: 'background 0.2s, transform 0.2s',
    boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
};

export default News;
